import { render, staticRenderFns } from "./SettingsDialog.vue?vue&type=template&id=63a30c8a&scoped=true&lang=pug"
import script from "./SettingsDialog.vue?vue&type=script&lang=js"
export * from "./SettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./SettingsDialog.vue?vue&type=style&index=0&id=63a30c8a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a30c8a",
  null
  
)

export default component.exports